import { SchoolFeature } from 'enums';

export const SCHOOL_FEATURE_POLICY_ENDPOINTS = {
  MINE: '/school-feature-policy/me',
  SCHOOL: (schoolId: string) =>
    `/school-feature-policy/schools/${encodeURIComponent(schoolId)}`,
  HISTORY: (schoolId: string) =>
    `/school-feature-policy/schools/${encodeURIComponent(schoolId)}/history`
} as const;

export const SCHOOL_FEATURE_LOCKED_ERROR = 'SCHOOL_FEATURE_LOCKED';

export const SCHOOL_FEATURE_HISTORY_PREVIEW_COUNT = 5;

export const SCHOOL_FEATURE_LABEL_KEYS: Record<
  SchoolFeature,
  { label: string; explanation: string }
> = {
  [SchoolFeature.AI_FEATURES]: {
    label: 'school_feature_policy.features.ai_features.label',
    explanation: 'school_feature_policy.features.ai_features.explanation'
  },
  [SchoolFeature.AI_VOICE_TRANSCRIPTION]: {
    label: 'school_feature_policy.features.ai_voice_transcription.label',
    explanation:
      'school_feature_policy.features.ai_voice_transcription.explanation'
  },
  [SchoolFeature.HEALTH_INTEGRATIONS]: {
    label: 'school_feature_policy.features.health_integrations.label',
    explanation: 'school_feature_policy.features.health_integrations.explanation'
  },
  [SchoolFeature.LOCATION_ROUTINES]: {
    label: 'school_feature_policy.features.location_routines.label',
    explanation: 'school_feature_policy.features.location_routines.explanation'
  },
  [SchoolFeature.SESSION_REPLAY]: {
    label: 'school_feature_policy.features.session_replay.label',
    explanation: 'school_feature_policy.features.session_replay.explanation'
  },
  [SchoolFeature.THIRD_PARTY_INTEGRATIONS]: {
    label: 'school_feature_policy.features.third_party_integrations.label',
    explanation:
      'school_feature_policy.features.third_party_integrations.explanation'
  },
  [SchoolFeature.SHARED_PROJECT_COMMENTS]: {
    label: 'school_feature_policy.features.shared_project_comments.label',
    explanation:
      'school_feature_policy.features.shared_project_comments.explanation'
  }
};
